import * as z from "zod";

const ConsolidationScheduleIntervalSchema = z.number().int().min(1).max(99);

const ConsolidationMonthDaySchema = z
  .number()
  .int()
  .refine(
    (monthDay) => monthDay === -1 || (monthDay >= 1 && monthDay <= 31),
    "Monthly dates must be between 1 and 31, or the last day",
  );

const ConsolidationWeekDaySchema = z.enum([
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU",
]);

export const ConsolidationScheduleRecurrenceSchema = z.discriminatedUnion(
  "frequency",
  [
    z.object({
      frequency: z.literal("daily"),
      interval: ConsolidationScheduleIntervalSchema,
    }),
    z.object({
      frequency: z.literal("weekly"),
      interval: ConsolidationScheduleIntervalSchema,
      weekDays: z.array(ConsolidationWeekDaySchema).min(1),
    }),
    z.object({
      frequency: z.literal("monthly"),
      interval: ConsolidationScheduleIntervalSchema,
      monthDays: z.array(ConsolidationMonthDaySchema).min(1),
    }),
  ],
);
